import React from 'react';
import PropTypes from 'prop-types';

import { IMAGES } from '@constants/images';
import { APP_ROUTES } from '@constants/routes';

import Image from '../Image/Image';
import Link from '../Link/Link';

const LOGO_TYPES = {
  DEFAULT: IMAGES.BRANDING.LOGO,
  MOBILE: IMAGES.BRANDING.LOGO_MOBILE
};

const Logo = (props) => {
  const {
    className,
    width,
    height,
    size = {
      height: 39,
      width: 147
    },
    mobile,
    withoutNavigation = false,
  } = props;

  const variant = mobile
    ? LOGO_TYPES.MOBILE
    : LOGO_TYPES.DEFAULT;

  const content = (
    <Image
      src={variant}
      width={width || size?.width}
      height={height || size?.height}
      optimize
      alt="Freshful"
    />
  );

  if (withoutNavigation) {
    return (
      <div className={className}>
        {content}
      </div>
    );
  }

  return (
    <Link href={APP_ROUTES.HOME}>
      <a className={className}>
        {content}
      </a>
    </Link>

  );
};

Logo.types = LOGO_TYPES;

Logo.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  mobile: PropTypes.bool,
  withoutNavigation: PropTypes.bool,
};

export default Logo;
